import React from 'react';
import { Button, Col, Drawer, Form, Row } from 'antd';

import { useScreenSize } from '../../../hooks';

export type IFiltersProps<T> = {
  open: boolean;
  onClose: () => void;
  onChange: (values: T) => void;
};

type InternalFiltersProps<T> = {
  children: React.ReactNode;
  initialValues: T;
  defaultValues: T;
} & IFiltersProps<T>;

export function NewCrudFilters<T>(props: InternalFiltersProps<T>) {
  const [myForm] = Form.useForm();

  const isSmallScreen = useScreenSize();

  const onApply = () => {
    props.onChange(myForm.getFieldsValue());

    if (isSmallScreen) {
      props.onClose();
    }
  };

  const onClear = () => {
    myForm.setFieldsValue(props.defaultValues);
    props.onChange(props.defaultValues!);

    if (isSmallScreen) {
      props.onClose();
    }
  };

  const form = (
    <Form layout="vertical" form={myForm} initialValues={props.initialValues!}>
      <Row gutter={8}>
        {props.children}
        <Col xs={24} xl={4}>
          <Row gutter={8}>
            <Col flex="1">
              <Button style={{ width: '100%' }} className="btn-filter notransition" type="default" onClick={onClear}>
                Clear
              </Button>
            </Col>
            <Col flex="1">
              <Button style={{ width: '100%' }} className="btn-filter notransition" type="default" onClick={onApply}>
                Apply
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );

  if (isSmallScreen) {
    return (
      <Drawer title="Filters" placement="bottom" onClose={props.onClose} visible={props.open} height="auto">
        {form}
      </Drawer>
    );
  }

  return <div className="filter-container">{form}</div>;
}
